export const POSTS = [
  {
    slug: "stock-market-dynamics-india",
    title: "Unveiling the Dynamics of the Stock Market: A Strategic Approach for India's Next Wave of Traders",
    excerpt:
      "While luck might open a few doors in the stock market, real, lasting wealth comes from discipline. A look at the Indian market, who plays in it, and why 93% of retail traders still lose.",
    date: "Dec 18, 2025",
    readMins: 7,
    tag: "Market Insights",
    cover: "linear-gradient(135deg, #084392, #0a55b7)",
  },
];
